module.exports = __webpack_public_path__ + "img/expression3.357fa529.png";